/**
 * ページ(またはセクション)の見出し行(設計書 §5)。件数などの補足・主な操作ボタン。業務ロジックは持たない。
 *
 * **見出しの文字は画面には出さない**(上のバー(メニューボタンの右)に同じページ名が出ていて二重になるため。
 * 2026-09-20 発注者指示)。読み上げ・検索のために h1 は残し、目で見えないようにする。
 */
import type { ReactNode } from 'react';

export default function PageHeader({ title, meta, actions, description }: { title: ReactNode; meta?: ReactNode; actions?: ReactNode; description?: ReactNode }) {
  return (
    <div className="page-header">
      <div className="page-header-row">
        <h1 className="page-header-title sr-only">{title}</h1>
        {meta && <span className="page-header-meta">{meta}</span>}
        {actions && <div className="page-header-actions">{actions}</div>}
      </div>
      {description && <p className="page-header-desc">{description}</p>}
    </div>
  );
}
